<template>
  <div>
    <v-container fluid grid-list-xl px-0 py-2>
      <v-layout row wrap>
        <v-flex sm12 md8>
          <base-card>
            <v-card-title primary-title class="px-2 py-0">
              <v-layout row align-center mt-2>
                <v-flex pa-0>
                  <h1 class="title">{{ $t('CART.CHECKOUT') }}</h1>
                </v-flex>
                <v-flex pa-0 text-xs-right>
                  <tk-btn
                    flat
                    v-if="!$auth.currentUser"
                    @click="$app.loginDialog = true"
                    class="text-none"
                  >
                    {{ $t('COMMON.LOGIN') }}
                    <v-icon right size="16">fas fa-key</v-icon>
                  </tk-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-form autocomplete="off" class="my-4">
              <v-layout row wrap>
                <v-flex xs12>
                  <tk-country-select
                    v-model="form.billing.country_id"
                    :error-messages="errors['billing.country_id']"
                    @focus="errors.country_id = null"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="errors['billing.first_name']"
                    @focus="errors.first_name = null"
                    v-model="form.billing.first_name"
                    :label="$t('SIGNUP.FIRST_NAME')"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="errors['billing.last_name']"
                    @focus="errors.last_name = null"
                    v-model="form.billing.last_name"
                    :label="$t('SIGNUP.LAST_NAME')"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="errors['billing.email']"
                    @focus="errors.email = null"
                    v-model="form.billing.email"
                    :label="$t('COMMON.EMAIL')"
                    type="email"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="errors['billing.phone']"
                    @focus="errors.phone = null"
                    v-model="form.billing.phone"
                    :label="$t('SIGNUP.PHONE')"
                    type="tel"
                    required
                  />
                </v-flex>

                <template v-if="form.is_business">
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="errors['billing.company_name']"
                      @focus="errors.company_name = null"
                      v-model="form.billing.business_name"
                      :label="$t('GIFT_CARD.COMPANY_NAME')"
                      required
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="errors['billing.business_id']"
                      @focus="errors.business_id = null"
                      v-model="form.billing.business_id"
                      :label="$t('GIFT_CARD.BUSINESS_ID')"
                      required
                    />
                  </v-flex>
                </template>
                <v-flex xs12>
                  <v-text-field
                    :error-messages="errors['billing.address']"
                    @focus="errors.address = null"
                    v-model="form.billing.address"
                    :label="$t('SIGNUP.ADDRESS')"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="errors['billing.zip']"
                    @focus="errors.zip = null"
                    v-model="form.billing.zip"
                    :label="$t('SIGNUP.ZIP')"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="errors['billing.city']"
                    @focus="errors.city = null"
                    v-model="form.billing.city"
                    :label="$t('SIGNUP.CITY')"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    class="mt-2"
                    v-model="form.is_business"
                    :label="$t('CART.CORPORATE_CLIENT')"
                    color="primary"
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </base-card>
        </v-flex>
        <v-flex sm12 md4>
          <base-card v-if="$cart.giftCards.length" color="accent" class="pa-3">
            <h2 class="my-4">{{ $t('GIFT_CARD.YOUR_ORDER') }}</h2>
            <v-layout row pl-3 pb-2>
              <v-flex xs8 pa-0>
                <div class="subheading font-weight-bold">{{ $t('GIFT_CARD.PRODUCT_NAME')}}</div>
              </v-flex>
              <v-flex xs4 pa-0 text-xs-right pr-3>
                <div class="subheading font-weight-bold">{{ $t('CART.TOTAL')}}</div>
              </v-flex>
            </v-layout>
            <v-divider />
            <div row v-for="(order, i) in $cart.giftCards" :key="i">
              <v-layout pl-3 align-center>
                <v-flex xs6 pt-4 pl-0>{{ order.name }}</v-flex>
                <v-flex
                  xs6
                  pt-4
                  pl-0
                  text-xs-right
                >{{ order.amount | currency }} ({{ $t('CART.VAT') }} 0.00)</v-flex>
              </v-layout>
              <v-divider />
            </div>
            <v-layout row pl-3 py-2>
              <v-flex xs8 pa-0>
                <div class="subheading font-weight-bold">{{ $t('CART.TOTAL')}}</div>
              </v-flex>
              <v-flex xs4 pa-0 text-xs-right pr-3>
                <div class="subheading font-weight-bold">{{ $cart.giftCardTotal | currency }}</div>
              </v-flex>
            </v-layout>

            <div
              v-if="$cart.printGiftCard"
              class="my-2 font-weight-bold"
            >{{ $t('GIFT_CARD.PRINT_CONFIRM_TEXT') }}</div>

            <tk-btn
              class="mt-4"
              block
              type="button"
              color="primary"
              :loading="loading"
              @click="submit"
            >{{ $t('CART.PURCHASE') }}</tk-btn>
          </base-card>
          <tk-payment-options class="mt-4" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!

    next(vm => {
      console.log("BeforeRouerEnter", vm.$cart.giftCards);
      if (!vm.$cart.giftCards.length) {
        console.log("Redirec");
        next({ name: "giftcard" });
      }
    });
  },

  components: {
    TkPaymentOptions: () => import("@/components/core/TkPaymentOptions"),
    TkCountrySelect: () => import("@/components/core/TkCountrySelect.vue"),
  },

  data() {
    return {
      loading: false,
      form: {
        is_business: false,
        billing: {},
        gift_cards: [],
        print: this.$cart.printGiftCard
      },
      errors: {}
    };
  },

  watch: {
    "$auth.currentUser": "onAuthChange"
  },

  created() {
    console.log(this.$auth.currentUser);
    if (this.$auth.currentUser) this.onAuthChange(this.$auth.currentUser);
  },

  methods: {
    onAuthChange(user) {
      console.log("OnAuthChange", user);
      this.form.billing.first_name = user.firstName;
      this.form.billing.last_name = user.lastName;
      this.form.billing.email = user.email;
      this.form.billing.phone = user.phone;
      this.form.billing.address = user.addressline1;
      this.form.billing.zip = user.zip;
      this.form.billing.city = user.city;
      this.form.billing.country_id = user.countryId;
    },
    async submit() {
      this.loading = true;
      this.errors = {};
      console.log("Submit", this.form);

      this.form.gift_cards = this.$cart.giftCards.map(gc => {
        return {
          amount: gc.amount,
          name: gc.name
          // print: this.$cart.printGiftCard
        };
      });

      console.log(this.form);

      try {
        const res = await this.$axios.post("/checkout/gift-card", this.form);
        console.log("Giftcard checkout success", res);
        const url = res.data.data.url;
        window.location.href = url;
      } catch (error) {
        if (error.status === 422 && error.data) {
          this.errors = error.data.errors;
          console.log(this.errors);
        }
      }
      this.loading = false;
    }
  }
};
</script>
